import React, { FunctionComponent } from 'react';

import { Route } from 'react-router-dom';

import { CallPage } from '../../../../../../pages/call';
import type { ErrorPageType } from '../../../../../components/error-page/types';

interface OnlyCallsViewProps {
    errorPageType: ErrorPageType | null;
}

export const OnlyCallsView: FunctionComponent<OnlyCallsViewProps> = ({ errorPageType }) => {
    if (errorPageType) {
        return null;
    }

    return (
        <Route path="/j/:id">
            <CallPage />
        </Route>
    );
};
